import { formatStringDate, parseTextWithShortcode } from '../../../utilities';
import * as React from 'react';
import { rem } from 'polished';
import styled from 'styled-components';
import { Content } from '../../../containers/CMS/CMS';
import ProductPreview from '../../_helpers/product/ProductPreview';
import { __ } from '@bart.sk-eshop/react-i18n/lib';
import {
  ProductColWrapper,
  ProductsRowWrapper,
} from '../../../containers/Category/Category';
import { Title } from '../Page/ContentContainer';
import ContestGeneratedForm from '../../ContestGeneratedForm/ContestGeneratedForm';
import MetaTags from '../../MetaTags/MetaTags';
import {
  Button,
  ButtonStyledStyles,
  ButtonStyles,
} from '../../_helpers/form/Button';

const ProductsHeading = styled.h1`
  font-size: ${rem(30)};
  color: #211e1f;
  font-weight: 700;
  &:after {
    content: ' ';
    display: block;
    border: ${rem(2)} solid ${({ theme }) => theme.color.secondary};
    width: ${rem(125)};
  }
`;

const ArticleDate = styled.div`
  color: gray;
`;

const ProductsWrapper = styled.div`
  clear: left;
`;

const CTAButtonWrapper = styled.div`
  display: flex;
  margin-top: ${rem(16)};
  justify-content: center;
`;

const CTAButton = styled(Button)`
  ${ButtonStyles};
  ${ButtonStyledStyles};

  &.lg {
    padding: ${rem(14)} ${rem(15)};
    ${({ theme }) => theme.media('sm')} {
      font-size: ${rem(16)};
      padding: ${rem(14)} ${rem(40)};
    }
  }
`;

interface Props {
  contentData: any;
  connectedProducts?: any;
  location?: any;
  ctaButton?: {
    text: string;
    url: string;
  };
}

class ArticleSingle extends React.PureComponent<Props> {
  public render() {
    const metaTags = {};
    if (this.props.contentData?.draft) {
      metaTags['robots'] = 'noindex';
    }

    return (
      <div>
        <MetaTags tags={metaTags} />
        <Title>{this.props.contentData.name}</Title>
        <ArticleDate>
          {' '}
          {formatStringDate(this.props.contentData.custom_date)}{' '}
        </ArticleDate>

        <>
          {parseTextWithShortcode(
            this.props?.contentData?.json_content?.body,
          ).map((item: any) => {
            if (item.type === 'text') {
              return (
                <Content
                  dangerouslySetInnerHTML={{
                    __html: item.value,
                  }}
                />
              );
            } else if (item.type === 'formular-sutaz') {
              return (
                <ContestGeneratedForm
                  nameJson={item.parameters.name}
                  customJson={item.parameters.custom}
                />
              );
            }

            return '';
          })}
        </>

        {this.props.connectedProducts &&
        this.props.connectedProducts.products &&
        this.props.connectedProducts.products.length ? (
          <ProductsWrapper>
            <ProductsHeading>
              {__('Odporúčané produkty v eshope')}
            </ProductsHeading>
            <ProductsRowWrapper>
              {this.props.connectedProducts.products.map((product) => {
                return (
                  <ProductColWrapper key={product.product_id}>
                    <ProductPreview product={product} />
                  </ProductColWrapper>
                );
              })}
            </ProductsRowWrapper>
          </ProductsWrapper>
        ) : (
          ''
        )}

        {typeof this.props.ctaButton?.url === 'string' &&
        typeof this.props.ctaButton?.text === 'string' ? (
          <CTAButtonWrapper>
            <a href={this.props.ctaButton.url}>
              <CTAButton className="primary lg">
                {' '}
                {this.props.ctaButton.text}{' '}
              </CTAButton>
            </a>
          </CTAButtonWrapper>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

export default ArticleSingle;
